export const data = [
  {
    id: 1,
    image: "/images/placements/1.png",
    name: "Hardeep Kaur",
    stream: "B.Tech. (CSE)",
    company: "GOTESO",
  },
  {
    id: 2,
    image: "/images/placements/6p.png",
    name: "Pawandeep Singh",
    stream: "B.Tech. (CSE)",
    company: "NUCLEUS SOFTWARE AND ECPL",
  },
  {
    id: 3,
    image: "/images/placements/2.png",
    name: "Gurpreet Singh",
    stream: "B.Tech. (ME)",
    company: "SV Footwear",
  },
  {
    id: 4,
    image: "/images/placements/3p.png",
    name: "Devinderpal Singh",
    stream: "B.Tech. (ME)",
    company: "SV Footwear",
  },
  {
    id: 5,
    image: "/images/placements/4p.png",
    name: "Jyoti Sharma",
    stream: "B.Tech. (CSE)",
    company: "INIZ Solutions",
  },
  {
    id: 6,
    image: "/images/placements/5p.png",
    name: "Ruby Kala",
    stream: "B.Tech. (CSE)",
    company: "BEBO Technology & Seasia",
  },
  {
    id: 7,
    image: "/images/placements/7p.png",
    name: "Aishlee Badhan",
    stream: "B.Tech. (CSE)",
    company: "TCS",
  },
  {
    id: 8,
    image: "/images/placements/8p.png",
    name: "Ayush Yadav",
    stream: "B.Tech. (ME)",
    company: "SV Footwear",
  },
  {
    id: 9,
    image: "/images/placements/9p.png",
    name: "Sweksha Shukla",
    stream: "B.Tech. (CSE)",
    company: "EDUCATION CULTURE PVT. LTD.",
  },
  {
    id: 10,
    image: "/images/placements/10p.png",
    name: "Muskan Dhingra",
    stream: "B.Tech. (CSE)",
    company: "Pepcoding Education Private Limited",
  },

  // Newly Added Entries

  {
    id: 11,
    image: "/images/placements/Vishal MCA Red Tape Limited.jpg",
    name: "Vishal",
    stream: "MCA",
    company: "Red Tape Limited",
  },
  {
    id: 12,
    image: "/images/placements/Vishakha J W Marriot.jpg",
    name: "Vishakha",
    stream: "BHMCT",
    company: "J W Marriot",
  },
  {
    id: 13,
    image: "/images/placements/vibha gill MBA Muthoot Finance.jpg",
    name: "Vibha Gill",
    stream: "MBA",
    company: "Muthoot Finance",
  },
  {
    id: 14,
    image: "/images/placements/Tarun MCA CT Maqsudan Campus.jpg",
    name: "Tarun",
    stream: "MCA",
    company: "CT Maqsudan Campus",
  },
  {
    id: 15,
    image: "/images/placements/TANIYA MBA Arvind Fashions.jpeg",
    name: "Taniya",
    stream: "MBA",
    company: "Arvind Fashions",
  },
  {
    id: 16,
    image: "/images/placements/Simran_MCA_Sacred Heart hospital.jpg",
    name: "Simran",
    stream: "MCA",
    company: "Sacred Heart Hospital",
  },
  {
    id: 17,
    image: "/images/placements/Shivam MCA LTD Technology .jpg",
    name: "Shivam",
    stream: "MCA",
    company: "LTD Technology",
  },
  {
    id: 18,
    image: "/images/placements/Shaanu BHMCT J W Marriot.jpg",
    name: "Shaanu",
    stream: "BHMCT",
    company: "J W Marriot",
  },
  {
    id: 19,
    image: "/images/placements/Renu BHMCT Courtyard.jpg",
    name: "Renu",
    stream: "BHMCT",
    company: "Courtyard",
  },
  {
    id: 20,
    image: "/images/placements/Ranjana BHMCT Vocco by IHG Amritsar.jpg",
    name: "Ranjana",
    stream: "BHMCT",
    company: "Vocco by IHG Amritsar",
  },
  {
    id: 21,
    image: "/images/placements/Rajdeep BHMCT Holidat Inn.jpg",
    name: "Rajdeep",
    stream: "BHMCT",
    company: "Holiday Inn",
  },
  {
    id: 22,
    image: "/images/placements/Priyanshu MCA CT Shahpur.jpg",
    name: "Priyanshu",
    stream: "MCA",
    company: "CT Shahpur",
  },
  {
    id: 23,
    image: "/images/placements/priya Joshi MBA Muthoot Finance.jpg",
    name: "Priya Joshi",
    stream: "MBA",
    company: "Muthoot Finance",
  },
  {
    id: 24,
    image: "/images/placements/Paras BHMCT Reddison Blue.jpg",
    name: "Paras",
    stream: "BHMCT",
    company: "Radisson Blu",
  },
  {
    id: 25,
    image: "/images/placements/Nisha BHMCT Courtyard.jpg",
    name: "Nisha",
    stream: "BHMCT",
    company: "Courtyard",
  },
  {
    id: 26,
    image: "/images/placements/navneet MBA Singlemind Infotech.jpeg",
    name: "Navneet",
    stream: "MBA",
    company: "Singlemind Infotech",
  },
  {
    id: 27,
    image: "/images/placements/Navjot Kaur BHMCT J W Marriot.jpg",
    name: "Navjot Kaur",
    stream: "BHMCT",
    company: "J W Marriot",
  },
  {
    id: 28,
    image: "/images/placements/Muskan MCA Innocent Heart.jpg",
    name: "Muskan",
    stream: "MCA",
    company: "Innocent Heart",
  },
  {
    id: 29,
    image: "/images/placements/Manpreet_MCA_Sacred Heart hospital.jpg",
    name: "Manpreet",
    stream: "MCA",
    company: "Sacred Heart Hospital",
  },
  {
    id: 30,
    image: "/images/placements/Manjot BHMCT Courtyard.jpg",
    name: "Manjot",
    stream: "BHMCT",
    company: "Courtyard",
  },

  {
    id: 31,
    image: "/images/placements/Kunal_MCA_sakaar micro solutions.jpg",
    name: "Kunal",
    stream: "MCA",
    company: "Sakaar Micro Solutions",
  },

  {
    id: 32,
    image: "/images/placements/Kirti BHMCT Vocco by IHG Amritsar .jpg",
    name: "Kirti",
    stream: "BHMCT",
    company: "Vocco by IHG Amritsar",
  },

  {
    id: 33,
    image: "/images/placements/khushi MBA Muthoot Finance.jpg",
    name: "Khushi",
    stream: "MBA",
    company: "Muthoot Finance",
  },

  {
    id: 34,
    image: "/images/placements/Himanshi J W Marriot.jpg",
    name: "Himanshi",
    stream: "BHMCT",
    company: "J W Marriot",
  },

  {
    id: 35,
    image: "/images/placements/himani MBA Muthoot Finance.jpeg",
    name: "Himani",
    stream: "MBA",
    company: "Muthoot Finance",
  },

  {
    id: 36,
    image: "/images/placements/harshpal MBA Muthoot Finance.jpg",
    name: "Harshpal",
    stream: "MBA",
    company: "Muthoot Finance",
  },

  {
    id: 37,
    image: "/images/placements/Harshdeep BHMCT Vocco IHG Amritsar.jpg",
    name: "Harshdeep",
    stream: "BHMCT",
    company: "Vocco IHG Amritsar",
  },

  {
    id: 38,
    image: "/images/placements/Harpreet MCA Sacred Heart Hospital.jpg",
    name: "Harpreet",
    stream: "MCA",
    company: "Sacred Heart Hospital",
  },

  {
    id: 39,
    image: "/images/placements/Zeeshan BTECH CSE 75way Technologies.png",
    name: "Zeeshan",
    stream: "BTECH CSE",
    company: "75way Technologies",
  },

  {
    id: 40,
    image: "/images/placements/Vishal BTECH CSE O7 Services.jpeg",
    name: "Vishal",
    stream: "BTECH CSE",
    company: "O7 Services",
  },

  {
    id: 41,
    image: "/images/placements/Vishal BSC MLS Dubai Royal hospital.jpg",
    name: "Vishal",
    stream: "BSC MLS",
    company: "Dubai Royal Hospital",
  },

  {
    id: 42,
    image:
      "/images/placements/Veerpal BTECH CSE Netsmartz Infotech (India) Pvt. Ltd.jpeg",
    name: "Veerpal",
    stream: "BTECH CSE",
    company: "Netsmartz Infotech (India) Pvt. Ltd",
  },

  {
    id: 43,
    image: "/images/placements/Varsha BTECH CSE Coder Roots Mohali.jpeg",
    name: "Varsha",
    stream: "BTECH CSE",
    company: "Coder Roots Mohali",
  },

  {
    id: 44,
    image: "/images/placements/Vanshika BTECH DS AOSC TECHNOLOGIES.jpeg",
    name: "Vanshika",
    stream: "BTECH DS",
    company: "AOSC TECHNOLOGIES",
  },

  {
    id: 45,
    image: "/images/placements/Tanvir BTECH CSE Forensic care noida.PNG",
    name: "Tanvir",
    stream: "BTECH CSE",
    company: "Forensic Care Noida",
  },

  // {
  //   id: 46,
  //   image:
  //     "/images/placements/Taniya BTECH CSE SENSATION SOFTWARE SOLUTION.jpeg",
  //   name: "Taniya",
  //   stream: "BTECH CSE",
  //   company: "SENSATION SOFTWARE SOLUTION",
  // },

  {
    id: 47,
    image: "/images/placements/Summant BTECH ME Hero Cycles.jpeg",
    name: "Summant",
    stream: "BTECH ME",
    company: "Hero Cycles",
  },

  // {
  //   id: 48,
  //   image: "/images/placements/Soen BTECH CSE O7 Services.jpeg",
  //   name: "Soen",
  //   stream: "BTECH CSE",
  //   company: "O7 Services",
  // },

  {
    id: 49,
    image:
      "/images/placements/Simran BTECH CSE Paisso Technology Private Limited.jpg",
    name: "Simran",
    stream: "BTECH CSE",
    company: "Paisso Technology Private Limited",
  },

  {
    id: 50,
    image: "/images/placements/Simnan BSC RIT Aman Bhalla IMT Pathankot.jpg",
    name: "Simnan",
    stream: "BSC RIT",
    company: "Aman Bhalla IMT Pathankot",
  },

  {
    id: 51,
    image:
      "/images/placements/shweta BTECH ECE SPEEDWAYS TYRES PRIVATE LIMITED.jpg",
    name: "Shweta",
    stream: "BTECH ECE",
    company: "SPEEDWAYS TYRES PRIVATE LIMITED",
  },

  {
    id: 52,
    image:
      "/images/placements/Sapna BSC MLS Sigma Diagnostic Lab Jalandhar.jpg",
    name: "Sapna",
    stream: "BSC MLS",
    company: "Sigma Diagnostic Lab Jalandhar",
  },

  {
    id: 53,
    image: "/images/placements/Sameer BSC MTAOTT PIMS Hospital Jalandhar.jpg",
    name: "Sameer",
    stream: "BSC MTAOTT",
    company: "PIMS Hospital Jalandhar",
  },

  {
    id: 54,
    image:
      "/images/placements/Ritik BTECH CSE Netsmartz Infotech (India) Pvt. Ltd.jpeg",
    name: "Ritik",
    stream: "BTECH CSE",
    company: "Netsmartz Infotech (India) Pvt. Ltd",
  },

  {
    id: 55,
    image:
      "/images/placements/Rahul MSC Medical Micro Biology GRD Group of Colleges, Ropar.jpg",
    name: "Rahul",
    stream: "MSC Medical Micro Biology",
    company: "GRD Group of Colleges, Ropar",
  },

  {
    id: 56,
    image:
      "/images/placements/Rachna BSC MLS Devi talab Hospital Jalandhar.jpg",
    name: "Rachna",
    stream: "BSC MLS",
    company: "Devi Talab Hospital Jalandhar",
  },

  {
    id: 57,
    image: "/images/placements/Navneet Kaur BTECH CSE Pisoft Informatics.jpeg",
    name: "Navneet Kaur",
    stream: "BTECH CSE",
    company: "Pisoft Informatics",
  },

  {
    id: 59,
    image: "/images/placements/Muskan BTECH CSE SOLITAIRE INFOSYS.jpeg",
    name: "Muskan",
    stream: "BTECH CSE",
    company: "SOLITAIRE INFOSYS",
  },

  {
    id: 60,
    image: "/images/placements/Mohit singh BTECH ME Hero Cycles.JPG",
    name: "Mohit Singh",
    stream: "BTECH ME",
    company: "Hero Cycles",
  },

  {
    id: 61,
    image:
      "/images/placements/MIsha BTECH CSE Mind Code Lab Private limited.jpeg",
    name: "Misha",
    stream: "BTECH CSE",
    company: "Mind Code Lab Private Limited",
  },

  {
    id: 62,
    image:
      "/images/placements/Mehak BTECH ECE SPEEDWAYS TYRES PRIVATE LIMITED.jpg",
    name: "Mehak",
    stream: "BTECH ECE",
    company: "SPEEDWAYS TYRES PRIVATE LIMITED",
  },

  {
    id: 63,
    image:
      "/images/placements/MD Afzak BSC RIT Gupta Scan Centre Jalandhar.jpg",
    name: "MD Afzak",
    stream: "BSC RIT",
    company: "Gupta Scan Centre Jalandhar",
  },

  {
    id: 64,
    image: "/images/placements/Manrit BTECH CSE Coder Roots Mohali.jpeg",
    name: "Manrit",
    stream: "BTECH CSE",
    company: "Coder Roots Mohali",
  },

  {
    id: 65,
    image: "/images/placements/Manpreet Kaur BTECH CSE Tech Cadd ,Mohali.PNG",
    name: "Manpreet Kaur",
    stream: "BTECH CSE",
    company: "Tech Cadd, Mohali",
  },

  {
    id: 66,
    image: "/images/placements/Maninder BSC MLS EPILLO DIGNOSTIC LABS.jpg",
    name: "Maninder",
    stream: "BSC MLS",
    company: "EPILLO DIGNOSTIC LABS",
  },
];
